import {gql, MutationTuple, useMutation} from "@apollo/client";
import {orderFields, payerAuthenticationFields, redeemQuotationFields} from "../../../../fragments/live/order";

export function getPlaceOrderMutation(): MutationTuple<any, any> {
    return useMutation(gql`
        mutation PlaceOrder($orderData: PlaceOrderInput) {
            placeOrder(
                input: $orderData
            ) {
                order {
                    ...orderFields
                }

                payer_authentication {
                    ...payerAuthenticationFields
                }
            }
        }

        ${orderFields}
        ${payerAuthenticationFields}
    `);
}

export function getRedeemQuotationMutation(): MutationTuple<any, any> {
    return useMutation(gql`
        mutation RedeemQuotation($quotationData: RedeemQuotationInput!) {
            redeemQuotation(
                input: $quotationData
            ) {
                order {
                    ...redeemQuotationFields
                }

                payer_authentication {
                    ...payerAuthenticationFields
                }
            }
        }
        ${redeemQuotationFields}
        ${payerAuthenticationFields}
    `);
}

export function getUploadPurchaseOrderMutation(): MutationTuple<any, any> {
    return useMutation(gql`
        mutation UploadPurchaseOrder(
            $cartId: String!,
            $purchaseOrderNumber: String!,
            $poFile: NanoporeFile!,
            $additionalInformation: OntPaymentAdditionalInformationInput
        ) {
            uploadPurchaseOrder(
                input: {
                    cart_id: $cartId
                    purchase_order_number: $purchaseOrderNumber
                    po_file: $poFile
                    additional_information: $additionalInformation
                }
            ) {
                success
            }
        }
    `);
}
